/**
 * Group field limits + patterns.
 * Per SOP 15 Ch.17 Layer 2c (LOCKED 2026-05-14).
 */

export const GROUPNAMEMAX = 128
export const GROUPDESCMAX = 256
